import { render, staticRenderFns } from "./vue-signature.vue?vue&type=template&id=4e00d568&scoped=true"
import script from "./vue-signature.vue?vue&type=script&lang=js"
export * from "./vue-signature.vue?vue&type=script&lang=js"
import style0 from "./vue-signature.vue?vue&type=style&index=0&id=4e00d568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e00d568",
  null
  
)

export default component.exports